import { createReducer } from '../../helpers';
import { api } from '../../actions';

const initialState = {
    byContactId: {},
    ids: [],
    hasNext: true,
    next: null,
};

function updateConversation(state, action) {
    switch (action.type) {
        case api.conversations.assign.successType:
        case api.conversations.assignMe.successType:
        case api.messages.create.successType:
            state.byContactId[action.contactId] = action.result.conversation;
            break;
        case api.conversations.changeStatus.successType:
        case api.conversations.read.successType:
        case api.conversations.retrieve.successType:
            state.byContactId[action.contactId] = action.result;
            break;
        case api.contacts.update.successType:
            state.byContactId[action.contactId].contact = action.result;
            break;
    }
}

function addConversation(state, action) {
    state.byContactId[action.contactId] = action.payload;
    if (state.ids.indexOf(action.contactId) === -1) {
        state.ids.unshift(action.contactId);
    }
}

export default createReducer(initialState, {
    [api.conversations.list.success]: (state, action) => {
        if (!(action.query && action.query.next)) {
            state.ids = [];
        }

        state.hasNext = action.result.hasNext;
        state.next = action.result.next;

        action.result.results.forEach((item) => {
            state.byContactId[item.contact._id] = item;
            if (state.ids.indexOf(item.contact._id) === -1) {
                state.ids.push(item.contact._id);
            }
        });
    },
    [api.conversations.assign.successType]: updateConversation,
    [api.conversations.assignMe.successType]: updateConversation,
    [api.conversations.changeStatus.successType]: updateConversation,
    [api.conversations.read.successType]: updateConversation,
    [api.conversations.retrieve.successType]: updateConversation,
    [api.contacts.update.successType]: updateConversation,
    [api.listenUpdateConversation]: addConversation,
    [api.listenCreateConversation]: addConversation,
});
